import React, { useState, useEffect } from 'react'
import {
  CLIENT_APPLICATION_NAMES,
  TRACK_CONTENT_TYPES,
  TRACK_PROPS,
  type TrackContentType,
} from '@mc/track-event'
import { TrackingParamsProvider } from '@mc/tracking-context'
import {
  Video,
  VideoAutoplay,
  VideoContainer,
  VideoFullscreen,
  VideoPlayback,
  VideoScrubber,
  VideoSpacer,
  VideoTime,
  VideoVolume,
  useVideo,
} from '@mc/video'
import { DEFAULT_WRAPPER_CLASS_NAME, HeroVideoPoster } from './HeroVideoPoster'

const ForceMutedVideoAutoplay = ({ muted, ...props }: { muted?: boolean }) => {
  const { setMuted } = useVideo()

  useEffect(() => {
    setMuted(true)
  }, [setMuted])

  return <VideoAutoplay muted={muted} {...props} />
}

export const HeroVideo = ({
  mediaUuid,
  fallbackImageUrl,
  fullWidth = false,
  contentType = TRACK_CONTENT_TYPES.CERTIFICATE_HERO_AUTO_PLAY,
  className = DEFAULT_WRAPPER_CLASS_NAME,
  roundedClassName = 'rounded-md',
}: {
  mediaUuid?: string
  fallbackImageUrl: string
  fullWidth?: boolean
  contentType?: TrackContentType
  className?: string
  roundedClassName?: string
}) => {
  const [startVideo, setStartVideo] = useState(false)

  useEffect(() => {
    if (!mediaUuid) return () => {}

    const timeout = setTimeout(() => {
      setStartVideo(true)
    }, 2000)

    return () => {
      clearTimeout(timeout)
    }
  }, [mediaUuid])

  return (
    <HeroVideoPoster
      videoStarted={startVideo}
      fullWidth={fullWidth}
      className={className}
      roundedClassName={roundedClassName}
      fallbackImageUrl={fallbackImageUrl}
    >
      {/* Video */}
      {mediaUuid && (
        <TrackingParamsProvider
          value={{
            [TRACK_PROPS.CONTENT_ID]: mediaUuid,
            [TRACK_PROPS.CONTENT_TYPE]: contentType,
            [TRACK_PROPS.VIEW_CLIENT_APPLICATION_NAME]:
              CLIENT_APPLICATION_NAMES.CERTS,
          }}
        >
          <Video
            className='h-full'
            aspectRatio='auto'
            mediaUuid={mediaUuid}
            exemptSingleton
            playsInline
            loop
            muted
            fit='cover'
            poster={fallbackImageUrl}
            preload='none'
          >
            <VideoContainer>
              <VideoScrubber />
              <VideoPlayback />
              <VideoVolume />
              <VideoTime />
              <VideoSpacer />
              <VideoFullscreen />
            </VideoContainer>
            {startVideo && <ForceMutedVideoAutoplay muted />}
          </Video>
        </TrackingParamsProvider>
      )}
    </HeroVideoPoster>
  )
}
